<template>

    <div class="product product--list product--list-medium d-flex">
        <div class="product__thumbnail-wrapper">

            <catalog-slider type="pet" :photos="item.images" :idx="item.id"
                            v-if="media <= 576 && item.images && item.images.length > 1"/>

            <a class="product__thumbnail" :href="'/pets/' + item.id" target="_blank" v-else>

                <div v-if="!!item.avatar" class="product__thumbnail-image"
                     :style="'background-image: url(/storage/'+ (item.avatar.path.replace('original', 'preview_l')) +')'"></div>
                <div v-else class="product__thumbnail-image">{{$store.getters.t('catalog_pet_no_image')}}</div>

            </a>
        </div>
        <div class="product__details d-flex">
            <div class="product-desc">

                <div class="product_title">
                    <h4><a :href="'/pets/' + item.id" target="_blank">{{ item.name }}</a>
                    </h4>
                    <span class="product_title-info d-flex">

                        <span class="info-block" v-if="item.city"><span
                            class="lnr lnr-map-marker"></span> {{ item.city.name }}</span>
                        <span class="info-block info-block--secondary"><span
                            class="lnr lnr-heart"></span> {{ item.followers_count }} {{$store.getters.t('catalog_pet_followers')}}</span>

                    </span>
                </div>
                <p class="product_description">
                    {{ item.ad_title.substring(0, 50).trim() + '...' }} <a
                    :href="'/pets/' + item.id" target="_blank">{{$store.getters.t('catalog_pet_read_more')}}</a></p>
                <div class="author d-flex">
                    <div class="author-icon"
                         :class="{'author-icon--loyalty': item.user && item.user.loyalty_level}">
                        <img class="auth-img"
                             :src="'/storage' + item.user.avatar.path.replace('original', 'avatar')"
                             alt="author image" v-if="item.user.avatar">
                        <span>{{ getUserPM(item.user.name) }}</span>
                    </div>
                    <p class="v-name">
                        <a target="_blank"
                           :href="'/user/'+ item.user.id +'/profile'">{{ item.user.name }}</a>
                    </p>
                </div>


                <!-- TODO pet labels -->
                <div class="pet-labels d-flex" v-if="item.filters">
                    <div class="pet-labels__item d-flex" v-for="filter in item.filters"
                         :style="{background: filter.color ? filter.color : '#FEF1F1'}">
                        <img :src="`/assets/images/${filter.icon}`" alt=""
                             v-if="filter.icon">
                        <svg v-else width="15" height="13" viewBox="0 0 15 13"
                             fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M7.77666 0.545662L14.1914 5.33532C14.3942 5.49546 14.4376 5.78663 14.2783 5.99044C14.1914 6.12147 14.0466 6.1797 13.9018 6.1797C13.8149 6.1797 13.7136 6.15058 13.6267 6.09235L12.7144 5.40811V12.0758C12.7144 12.3378 12.5117 12.5416 12.2511 12.5416H2.73751C2.47686 12.5416 2.27414 12.3378 2.27414 12.0758V5.40811L1.36188 6.09235C1.15916 6.23793 0.869549 6.19426 0.710266 5.99044C0.565463 5.78663 0.608904 5.49546 0.811628 5.33532L7.22641 0.545662C7.38569 0.429197 7.61738 0.429197 7.77666 0.545662ZM6.41551 11.6099H8.58756H9.52878H11.7877V4.70932L7.50153 1.50651L3.21536 4.70932V11.5954H5.47429L6.41551 11.6099Z"
                                  fill="#91DA66"/>
                            <path
                                d="M7.50112 4.54747C6.94563 4.5475 6.40266 4.71313 5.94087 5.02335C5.47904 5.3336 5.11916 5.77451 4.90667 6.29027C4.69418 6.80602 4.63859 7.37351 4.74691 7.92099C4.85523 8.46848 5.12261 8.97146 5.51532 9.36628C5.90804 9.76111 6.40846 10.0301 6.95333 10.139C7.4982 10.248 8.06296 10.1921 8.57618 9.97833C9.0894 9.7646 9.52797 9.40271 9.83649 8.93849C10.145 8.47428 10.3096 7.92857 10.3096 7.37037V7.27037H10.2096H9.88464H9.78464V7.37037C9.78464 7.82463 9.65066 8.26864 9.39969 8.64626C9.14873 9.02387 8.79209 9.3181 8.37492 9.49182C7.95777 9.66554 7.49877 9.71099 7.05595 9.62243C6.61313 9.53388 6.2063 9.31528 5.88693 8.99419C5.56756 8.6731 5.35001 8.26395 5.26186 7.81843C5.17372 7.37292 5.21896 6.91113 5.39185 6.4915C5.56474 6.07187 5.85747 5.71329 6.23296 5.46105C6.60844 5.20881 7.04982 5.07421 7.50131 5.07421L7.50172 5.07421C7.805 5.07297 8.10544 5.13312 8.38514 5.25111C8.5163 5.30643 8.64439 5.40095 8.76976 5.51383C8.83562 5.57312 8.89895 5.6358 8.96053 5.69876H8.46197C8.34615 5.69876 8.25226 5.79265 8.25226 5.90847C8.25226 6.02429 8.34615 6.11818 8.46197 6.11818H9.45884C9.62453 6.11818 9.75884 5.98386 9.75884 5.81818V4.78872C9.75884 4.65546 9.6508 4.54743 9.51754 4.54745C9.3843 4.54746 9.2763 4.65548 9.2763 4.78872V5.25705C8.78229 4.83138 8.16194 4.54507 7.50112 4.54747ZM7.50112 4.54747C7.50118 4.54747 7.50124 4.54746 7.50131 4.54746V4.64746L7.50093 4.54747C7.501 4.54747 7.50106 4.54747 7.50112 4.54747Z"
                                fill="#91DA66" stroke="#91DA66" stroke-width="0.2"/>
                            <path
                                d="M7.45195 6.48565C7.45195 6.3959 7.3792 6.32315 7.28945 6.32315V6.32315C7.19971 6.32315 7.12695 6.3959 7.12695 6.48565V7.64371C7.12695 7.70184 7.15224 7.75709 7.19623 7.79508L8.09388 8.5703C8.16226 8.62935 8.26562 8.62152 8.32432 8.55284V8.55284C8.38259 8.48467 8.37484 8.38223 8.30697 8.3236L7.45195 7.58495V6.48565Z"
                                fill="#91DA66" stroke="#91DA66" stroke-width="0.6"/>
                        </svg>
                    </div>
                </div>

            </div>
            <!-- end /.product-desc -->


            <div class="product-purchase d-flex" v-if="item.need_sum > 0">

                <div class="sum_info d-flex">
                    <span>{{ item.donations_total ? parseInt(item.donations_total).toFixed() : 0 }} USD</span>
                    <span
                        class="sum_info--secondary">{{ parseInt(item.need_sum).toFixed() }} USD</span>
                </div>

                <div class="pet-progress progress">
                    <div class="progress-bar" role="progressbar"
                         :aria-valuenow="item.donations_progress" aria-valuemin="0"
                         aria-valuemax="100"
                         :style="'width:' + (item.donations_progress > 100 ? 100 : parseInt(item.donations_progress).toFixed()) +'%;'">
                                                        <span v-if="item.donations_total > 0">{{
                                                                parseInt(item.donations_progress).toFixed()
                                                            }}%</span>
                    </div>
                </div>

                <div class="labels clearfix d-flex">
                    <span class="already-have-money">{{$store.getters.t('catalog_pet_collected')}}</span>
                    <span class="already-have-money">{{$store.getters.t('catalog_pet_goal')}}</span>
                </div>

                <a :href="'/pets/' + item.id" class="btn btn-sm btn--round"
                   target="_blank">
                    {{$store.getters.t('catalog_pet_help')}}
                </a>

            </div>
            <div class="product-purchase product-purchase--center d-flex" v-else>

                <a :href="'/pets/' + item.id" class="btn btn-sm btn--round"
                   target="_blank">
                    {{$store.getters.t('catalog_pet_meet')}}
                </a>

            </div>
            <!-- end /.product-purchase -->


        </div>
    </div>

</template>

<script>

import CatalogSlider from "./CatalogSlider";

export default {
    name: "CatalogPets",
    components: { CatalogSlider },
    props: ['item'],
    data(){
        return{
            media: 0,
        }
    },

    created() {
        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },

    mounted(){
        this.myEventHandler();
    },

    methods:{
        myEventHandler(e) {
            this.media = window.innerWidth
        },
        getUserPM(name) {
            if (!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

    }

}
</script>

<style lang="scss" scoped>
.product:hover .product__thumbnail:before{
    display: none;
}

</style>
